import React from "react"
import { companyData } from "./data"

const DefaultTwitterMeta = () => {
  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={companyData.site} />
      <meta name="twitter:title" content={companyData.name} />
      <meta name="twitter:description" content={companyData.description} />
      <meta name="twitter:image" content={companyData.cover} />
    </>
  )
}

export default DefaultTwitterMeta
